<template>
  <div class>
    <drawer :title="checkInTitle" :dialogShow="checkInShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          
               <div class="totals-box plr24 mt20">
                  <div class="flex-row mb30">
                    <div class="itemName">顾客姓名</div>
                    <div>{{ form.customerName }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">顾客手机号</div>
                    <div>{{ form.mobile }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">建档门店</div>
                    <div>{{ form.shopIdCn }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">建档技师</div>
                    <div>{{ form.staffIdCn }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">来源</div>
                    <div>{{ form.repairOriginCn }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">档案金额</div>
                    <div>{{ form.shopId == userInfo.shopId ? '￥'+ form.amount: '****' }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">卡券优惠</div>
                    <div>{{ form.couponAmount ? '￥'+ form.couponAmount: '¥ 0' }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">已收金额</div>
                    <div>{{ form.shopId == userInfo.shopId ? '￥'+ form.realPayAmount: '****' }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">已收款次数</div>
                    <div>{{ form.repairPayRecordSize }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">分类</div>
                    <div>{{ form.categoryName }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">部位及个数</div>
                    <div>{{ form.symptom }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">原始备注</div>
                    <div>{{ form.remark }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">档案状态</div>
                    <div class="jishi">{{ form.repairStatusCn }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">登记次数</div>
                    <div class="jishi">{{ form.registrationNumber }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">档案编号</div>
                    <div>{{ form.docNo }}</div>
                  </div>
                  <div class="flex-row mb30" v-if="isNeedSms">
                    <div class="itemName">验证号码</div>
                    <div>{{ form.validMobile }}</div>
                  </div>
                  <div class="flex-row mb30" v-if="form.repairOrigin != 'merchantapp'">
                    <div class="itemName">会员卡绑定状态</div>
                    <div class="active" v-if="form.repairOrigin == 'paper' && form.memberId == null">未绑定</div>
                    <div class="active" v-else>已绑定</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">建档时间</div>
                    <div>{{ formatDate(form.recordTime) }}</div>
                  </div>
                  <div class="flex-row mb30" v-if="form.repairStatus == 'finish'">
                    <div class="itemName">完成时间</div>
                    <div>{{ formatDay(form.oxLtime) }}</div>
                  </div>
                  <div class="flex-row mb30" v-else-if="form.repairStatus == 'refund'">
                    <div class="itemName">退款时间</div>
                    <div>{{ formatDay(form.oxCtime) }}</div>
                  </div>
                  <div  v-else>
                    <div class="flex-row mb30">
                      <div class="itemName">下次登记时间</div>
                      <div>{{ formatDay(form.nextRepairTime) }}</div>
                    </div>
                    <div class="flex-row mb30"  v-if="form.repairStatus !== 'build'">
                      <div class="itemName">过期时间</div>
                      <div>{{ formatDay(form.validEndTime) }}</div>
                    </div>
                  </div>
                </div>

          </div>
          <div v-if="form.repairPayRecordList && form.repairPayRecordList.length != 0">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>收款记录</i></p>
            <div class="detail plr20">
              <el-table :data="form.repairPayRecordList" input-large header-cell-class-name="table_header_bgcolor">
                <el-table-column label="操作时间" width="180px">
                  <template slot-scope="scope">{{ formatDate(scope.row.oxCtime)}}</template>
                </el-table-column>
                <el-table-column prop="staffName" label=" 服务技师" width="auto"></el-table-column>
                <el-table-column prop="amount" label="收款金额" width="auto" align="right"></el-table-column>
            
              </el-table>
            </div>
          </div>

          <div v-if="refundList.length != 0">
            <p class="order-title-boxs" ><span class="blueBlock"></span><i>退款明细</i></p>
            <div class="totals-box mlr24">
              <el-row class="order-details">
                <el-col :span="10" class="pl10">商品名称</el-col>
                <el-col :span="3">数量</el-col>
                <el-col :span="4">退款</el-col>
                <el-col :span="4">社保补贴</el-col>
                <el-col :span="3" class="tRight pr10">扣除</el-col>
              </el-row>
              <el-row v-for="(item,index) in refundList" :key="index" class="mt20">
                <el-col :span="4" class="pl10 mb20 color999">审核状态</el-col>
                <el-col :span="20" class="mb20 tRight pr10">
                  <div :class="item.auditStatus == 'pass' || item.auditStatus == 'wait' ? 'jishi': 'moneys'">{{item.auditStatusCn}}</div>
                </el-col>
                <el-col :span="10" class="pl10">{{item.itemName}}</el-col>
                <el-col :span="3" class="color999">{{item.itemNum}}</el-col>
                <el-col :span="4" class="color999">{{item.refundAmount}}</el-col>
                <el-col :span="4" class="color999">{{item.socialSubsidyAmount}}</el-col>
                <el-col :span="3" class="tRight pr10">{{item.deductAmount}}</el-col>
                <el-col :span="4" class="pl10 mt20 color999">技师</el-col>
                <el-col :span="20" class="mt20 tRight pr10">
                    <div class="jishi">{{item.staffNames}}</div>
                </el-col>
              </el-row>
            </div>
          </div>
    

          <div class="repair-box">
            <div>
              <div v-for="(item,index) in form.recordList" :key="index" class="totals-box  mt20">
                <div class="top pr24">
                  <p class="order-title-boxs" ><span class="blueBlock"></span><i>{{formatDate(item.repairTime)}}</i></p>
                  <p
                    :class="item.auditStatus == 'refuse' ? 'moneys':'jishi'"
                  >{{ item.auditStatusCn }}</p>
                </div>
                <div class="flex-row mb30 pl24">
                  <p class="itemName">门店名称</p>
                  <p>{{ item.shopIdCn }}</p>
                </div>
                <div class="flex-row mb30 pl24">
                  <p class="itemName">备注信息</p>
                  <p>{{ item.remark }}</p>
                </div>
                <div class="flex-row mb30 pl24">
                  <p class="itemName">技师</p>
                  <p>{{ item.staffIdCn }}</p>
                </div>
                <div class="center-mains">
                  <div class="imgs">
                    <div class="space-between">
                      <p class="imgs-name">登记照片</p>
                      <p class="cur jishi" v-if="item.thisShopFlag && item.auditStatus != 'pass'" @click="updateRepair(item)">修改</p>
                    </div>
                    <div class="img-list">
                      <el-image
                        class="img"
                        v-for="(i,j) in item.imgUrlList"
                        :key="j"
                        :src="i"
                        title="点击放大图片"
                        :preview-src-list="previewList"
                        @click="handPreview(i)"
                      ></el-image>
                    </div>
                  </div>
                </div>
                <div class="center-mains" v-if="item.signImgUrl">
                  <div class="imgs">
                    <div class="space-between">
                      <p class="imgs-name">签名照片</p>
                    </div>
                    <div class="img-list">
                      <el-image
                        class="img"
                        :src="item.signImgUrl"
                        title="点击放大图片"
                        :preview-src-list="previewList"
                        @click="handPreview(item.signImgUrl)"
                      ></el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div class="drawer-footer pr24 pb10">
          <div class="btns">
            <el-button
              class="small-btn"
              @click="handleRepair"
              v-if="status == 'build' && form.invalidFlag"
            >档案作废</el-button>
            <el-button
              type="primary"
              class="small-btn"
              @click="handlePay"
              v-if="status == 'build' && form.payFlag"
            >立即支付</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <set-money ref="setMoneyForm" @handleChange="changeSetMoney"></set-money>
    <handle-edit ref="handleEditForm" @change="editChange"></handle-edit>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import setMoney from "./setMoney";
import member from "../../components/member";
import handleEdit from "./handle-edit";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { member, drawer, setMoney , handleEdit},
  data() {
    return {
      form: {},
      pageHeight: this.$store.getters.MainHeight,
      checkInTitle: "档案详情",
      checkInShow: false,
      status: null,
      shopImg: require("../../../assets/images/shop.png"),
      refundList: [],
      userInfo: {},
      previewList: [],
      isNeedSms: false
    };
  },
  created() {
    this.init();
  },
  mounted() {
    
  },
  
  methods: {
    init() {
      this.$on("set", function(org) {
        this.status = org.repairStatus;
        this.userInfo = this.$store.getters.ShopInfo;
        this.checkInShow = true;
        if (sessionStorage.getItem('appInit')) {
          let appInit = JSON.parse(sessionStorage.getItem('appInit'))
          this.isNeedSms = appInit?.configManagerVo?.documentRegister?.verificationCodeFlag ?? false
        }
        this.$api.get(this.$url.repairDocument.get, {
            id: org.id
          }).then(res => {
            if (res) {
              this.form = res;
              this.listRefundItem(this.form)
            }
          });
          
      });
    },
    editChange(org) {
      this.$api.get(this.$url.repairDocument.get, {
            id: this.form.id
          })
          .then(res => {
            if (res) {
              this.form = res;
              this.repairForm.repairDocumentId = this.form.id;
              // this.form.memberId = null;
            }
          });
      /*
                TODO 不知道干啥用的，淦！
            */
    },
    handPreview (url) {
      let imgUrl = []
      this.previewList = []
      if (url.indexOf("?") > -1) {
        let arr = url.split("?")
        imgUrl.push(arr[0])
      } else {
        imgUrl.push(url)
      }
      this.previewList = imgUrl
      console.log(this.previewList);
    },
    listRefundItem (form) {
      this.$api.get(this.$url.companyRefund.listRefundItemByRepairId, {repairDocId: form.id}).then(ret => {
        if (ret) {
          this.refundList = ret
        }
      });
    },
    back() {
      this.checkInShow = false;
    },
    handleChangeDrawer() {
      this.checkInShow = false;
      this.$emit("change", true);
    },
    memberChange(value) {
      this.form.memberId = value;
    },
    changeSetMoney(value) {
        if (value) {
            this.$api.get(this.$url.repairDocument.get, {
                id: this.form.id
            }).then(res => {
                if (res) {
                this.form = res;
                this.listRefundItem(this.form)
                }
            });
        }
    },
    handlePay() {
      this.$refs["setMoneyForm"].$emit("set", this.form);
    },
    updateRepair (item) {
      console.log(this.form,'sssssss');
      let a = JSON.parse(JSON.stringify(item.imgUrlList));
      this.repairForm = {
        imgUrlList: a,
        remark: item.remark,
        staffId: item.staffId,
        staffName: item.staffName,
        repairDocumentId: this.queryId,
        nextRepairTime: item.repairTime,
        categoryId: this.form.categoryId,
        memberId: this.form.memberId,
        repairStatusCn: this.form.repairStatusCn,
        id: item.id,
        updateFlag: true
      };
      this.$refs["handleEditForm"].$emit("set", {
        newOrOld: this.form.newDocAddFlag,
        payPeriodFlag: this.form.payPeriodFlag,
        mobile: this.form.mobile,
        categoryName: this.form.categoryName,
        symptom: this.form.symptom,
        newDocumentFlag: this.form.repairOrigin,
        repairForm: this.repairForm
      });
    },
    handleRepair() {
      this.$confirm("确定作废吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$api
            .get(this.$url.repairDocument.invalid, {
              id: this.form.id
            })
            .then(res => {
              if (res) {
                this.checkInShow = false;
                this.$message.success("操作成功");
                this.$emit("change", true);
              }
            });
        })
        .catch(() => {});
    },
    gotoCenter() {
      // window.close();
      this.$router.push("/collectMoney/center");
    },
    skipSendSms () {
      sessionStorage.setItem("sendSms", JSON.stringify({id: this.form.memberId, mobile: this.form.mobile, realName: this.form.customerName}))
      this.$router.push('/dataList/smsTemplate');
      this.$store.commit("setCurentPage", 'data');
      localStorage.setItem("setCurentUrl", '/dataList/smsTemplate');
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/edit.less";
.pay-mains {
  background: #fff;
}
.relatives {
  position: relative;
}

.sendSmsIcon {
  position: absolute;
  right: 16px;
  width: 30px;
  height: 30px;
  vertical-align: middle;
}
.repair-box {
    background: #fff;
    .top_box {
          div  {
            width: 33%;
          }
          .box-center {
              text-align: center;
          }
          .box-right {
              text-align: right;
          }
      }
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      .name {
        display: flex;
      }
      .shop-img {
        width: 27px;
        margin-right: 10px;
      }
      .status {
        color: @blue;
      }
    }
    .center-mains {
      color: #666;
      .imgs-name {
        padding: 0 0 20px;
        display: flex;
        font-weight: 500;
        align-items: center;
      }
      .imgs {
        padding: 0 24px 20px;
        .img-list {
          margin: 0
        }
        .img {
          border-radius: 5px;
          margin: 0 10px 10px 0;
          width: 80px;
          height: 80px;
        }
      }
      .remarks-box {
        padding: 0 20px;
        .remark {
          min-height: 60px;
          display: flex;
          align-items: center;
        }
        .text-area {
          margin-top: 7px;
          margin-bottom: 20px;
          /deep/ .el-textarea__inner {
            height: 76px;
          }
        }
      }
    }
  }
</style>
